/*eslint-disable*/
export const messages = JSON.parse("{}");
